/**
 * Whether an event landed inside a floating UI layer.
 *
 * Selects, menus and pickers render their dropdown into a portal on `body`, so
 * it is outside the panel that owns it in the DOM while still being part of it.
 * Any `document`-level "did you click away?" handler has to treat those as
 * inside, or choosing an option from a dropdown dismisses whatever opened it.
 *
 * Matches on MUI's layer roots, which are part of its public styling API.
 */
export const inFloatingLayer = (target: EventTarget | null): boolean =>
  target instanceof Element &&
  target.closest(".MuiPopover-root, .MuiModal-root") !== null;
